import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {}

  openDialog<T = any>(
    dialogClassRef: any,
    data?: any,
    dialogOptions?: MatDialogConfig
  ): Observable<T extends any ? T : any> {
    dialogOptions = {
      position: { top: '0px' },
      minWidth: '40%',
      disableClose: false,
      ...dialogOptions,
    };
    // TODO: review functionality / integration with MIQ
    // this.loadingStateService.setMode(LoadingIndicatorModes.Dialog);
    return this.dialog
      .open(dialogClassRef, { ...dialogOptions, data })
      .afterClosed()
      .pipe(
        take(1)
        // TODO: review functionality / integration with MIQ
        // finalize(() => this.loadingStateService.setMode(LoadingIndicatorModes.Full))
      );
  }

  showSnackBack(message: string, action: string): void {
    this.snackBar.open(message, action, { duration: 2000 });
  }
}
